export default function LoadFont() {
  const style = document.createElement('style');
  style.innerText = `
  @font-face {
    font-family: 'MiSans-Semibold';
    src: url(${require('./fonts/MiSans-Semibold.woff2')}) format('woff2');
    font-display: swap; /* 关键！避免阻塞渲染 */
  }

  @font-face {
    font-family: 'MiSans-Regular';
    src: url(${require('./fonts/MiSans-Regular.woff2')}) format('woff2');
    font-display: swap; /* 关键！避免阻塞渲染 */
  }

  // 繁英西葡德法俄
  @font-face {
    font-family: 'TWHK';
    src: url(${require('./fonts/SourceHanSansTWHK-Normal.otf')}) format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
    /* 或者 auto、block、fallback */
    // swap：优先使用系统字体直到自定义字体加载完成。
    // fallback：如果自定义字体加载时间较长，使用系统字体。
    // optional：如果自定义字体未加载，则继续使用系统字体。
  }

  // 韩
  @font-face {
    font-family: 'SansKR';
    src: url(${require('./fonts/SourceHanSansKR-Normal.otf')}) format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
    /* 或者 auto、block、fallback */
    // swap：优先使用系统字体直到自定义字体加载完成。
    // fallback：如果自定义字体加载时间较长，使用系统字体。
    // optional：如果自定义字体未加载，则继续使用系统字体。
  }
  // 日
  @font-face {
    font-family: 'SansJA';
    src: url(${require('./fonts/SourceHanSans-Normal.otf')}) format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
    /* 或者 auto、block、fallback */
    // swap：优先使用系统字体直到自定义字体加载完成。
    // fallback：如果自定义字体加载时间较长，使用系统字体。
    // optional：如果自定义字体未加载，则继续使用系统字体。
  }
  `;
  document.head.appendChild(style);
}
